import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "customMenu": "Обслуживание/Общая информация/Тех. обслуживание и ремонт",
  "customPath": "/service/to-repair",
  "description": "С целью поддержания автомобиля в превосходном состоянии и сохранения гарантии каждому владельцу автомобиля ŠKODA рекомендует регулярно проходить техобслуживание",
  "huggerTemplate": "default",
  "keywords": "",
  "name": "to-repair",
  "title": "Техническое обслуживание SKODA – ТО Шкода в официальном сервисе"
};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const SimpleMainStage = makeShortcode("SimpleMainStage");
const SimpleMainStageHeading = makeShortcode("SimpleMainStageHeading");
const SimpleMainStageButtonsWrapper = makeShortcode("SimpleMainStageButtonsWrapper");
const SimpleMainStageButton = makeShortcode("SimpleMainStageButton");
const DefaultPaddedSection = makeShortcode("DefaultPaddedSection");
const DefaultSectionText = makeShortcode("DefaultSectionText");
const DefaultSectionHeading = makeShortcode("DefaultSectionHeading");
const FeaturesSliderQueried = makeShortcode("FeaturesSliderQueried");
const QueriedGallery = makeShortcode("QueriedGallery");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <SimpleMainStage verticalAlign="center" horizontalAlign="left" src="/m/service-m53-hero.jpg" mobileSrc="/m/service-m53-hero.jpg" mdxType="SimpleMainStage">
  <SimpleMainStageHeading mdxType="SimpleMainStageHeading">ТЕХНИЧЕСКОЕ ОБСЛУЖИВАНИЕ</SimpleMainStageHeading>
  <SimpleMainStageButtonsWrapper mdxType="SimpleMainStageButtonsWrapper">
    <SimpleMainStageButton href="/service/apps/service-form" mdxType="SimpleMainStageButton">
      Записаться на сервис
    </SimpleMainStageButton>
  </SimpleMainStageButtonsWrapper>
    </SimpleMainStage>
    <DefaultPaddedSection bgColor="#FAFAFA" noPb mdxType="DefaultPaddedSection">
  <DefaultSectionText mdxType="DefaultSectionText">
    <p>
      С целью поддержания автомобиля в превосходном техническом состоянии и
      сохранения гарантийных обязательств в полном объеме каждому автомобилю
      ŠKODA необходимо регулярно проходить регламентное техническое
      обслуживание.
    </p>
    <p>
      Регулярное прохождение регламентного технического обслуживания в
      соответствии с требованиями Изготовителя является залогом долгой и
      безотказной работы основных узлов автомобиля.
    </p>
    <p>
      Для всех автомобилей ŠKODA, эксплуатирующихся на территории Российской
      Федерации, установлен фиксированный межсервисный интервал для планового
      технического обслуживания, что соответствует 15 000 км или одному году (в
      зависимости от того, что наступит ранее).
    </p>
  </DefaultSectionText>
    </DefaultPaddedSection>
    <DefaultPaddedSection bgColor="#FFF" noPb mdxType="DefaultPaddedSection">
  <DefaultSectionHeading mdxType="DefaultSectionHeading">
    ПРЕИМУЩЕСТВА ОФИЦИАЛЬНОГО ДИЛЕРА
  </DefaultSectionHeading>
  <FeaturesSliderQueried tags="service to-repair" mdxType="FeaturesSliderQueried" />
    </DefaultPaddedSection>
    <DefaultPaddedSection bgColor="#FAFAFA" mdxType="DefaultPaddedSection">
  <DefaultSectionHeading mdxType="DefaultSectionHeading">
    ОРИГИНАЛЬНЫЕ ДЕТАЛИ ДЛЯ ТЕХНИЧЕСКОГО ОБСЛУЖИВАНИЯ
  </DefaultSectionHeading>
    </DefaultPaddedSection>
    <QueriedGallery presetName="6" tags="service-details" noPb mdxType="QueriedGallery" />
    <DefaultPaddedSection bgColor="#FFF" noPb mdxType="DefaultPaddedSection">
  <DefaultSectionHeading mdxType="DefaultSectionHeading"> ПРЕДОСТАВЛЯЕМЫЕ УСЛУГИ </DefaultSectionHeading>
    </DefaultPaddedSection>
    <QueriedGallery presetName="3" tags="service-links-2" noPb mdxType="QueriedGallery" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      